// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"LinkButton_linkButton__e_j2u"};